module.exports = __webpack_public_path__ + "img/logo-kemendag.1aefde90.svg";